module.exports = __webpack_public_path__ + "img/placeholder-1-min.95e85511.jpeg";